import {
    CarOutlined, EnvironmentOutlined, PhoneOutlined, MailOutlined,
    CalendarOutlined, ToolOutlined, NumberOutlined, BankOutlined,
    UserOutlined, TeamOutlined, FileTextOutlined, AimOutlined,
    ClockCircleOutlined, DashboardOutlined
} from "@ant-design/icons";

const FieldRow = ({ icon, label, value }) => (
    <div className="flex items-start gap-3 rounded-lg bg-gray-50 px-4 py-3">
        <div className="text-red-600 text-lg mt-0.5">{icon}</div>
        <div className="min-w-0">
            <div className="text-xs uppercase tracking-wider text-slate-500">{label}</div>
            <div className="text-slate-900 font-medium break-words">
                {value || <span className="text-slate-400">—</span>}
            </div>
        </div>
    </div>
);

const EquipmentDetailView = ({ data }) => {
    if (!data) return null;

    return (
        <div className="rounded-2xl min-w-lg border border-slate-200 bg-white shadow-sm">
            <div className="p-6 border-b border-slate-100">
                <div className="flex items-center gap-3">
                    <div className="h-12 w-12 rounded-full bg-gray-100 text-red-600 flex items-center justify-center">
                        <CarOutlined className="text-xl" />
                    </div>
                    <div>
                        <h1 className="text-2xl font-semibold text-slate-900 mb-0">
                            {data.equipment_name || "Equipment"}
                        </h1>
                        <p className="text-sm text-slate-500 mb-0">{data.vehicle_no}</p>
                    </div>
                </div>
            </div>

            <div className="p-6">
                <div className="grid md:grid-cols-4 gap-4">
                    <FieldRow icon={<ToolOutlined />} label="Equipment Type" value={data.equipment_type} />
                    <FieldRow icon={<CarOutlined />} label="Equipment Name" value={data.equipment_name} />
                    <FieldRow icon={<NumberOutlined />} label="Vehicle No" value={data.vehicle_no} />
                    <FieldRow icon={<NumberOutlined />} label="GPS IMEI No" value={data.gps_imei_no} />
                    <FieldRow icon={<ToolOutlined />} label="Fuel Type" value={data.fuel_type} />
                    <FieldRow icon={<AimOutlined />} label="Hiring Purpose" value={data.hiring_purpose} />
                    <FieldRow icon={<BankOutlined />} label="Manufacturer" value={data.manufacturer} />
                    <FieldRow icon={<CalendarOutlined />} label="Manufacturing Year" value={data.manufacturing_year} />
                    <FieldRow icon={<EnvironmentOutlined />} label="Deployment Area" value={data.deployment_area} />
                    <FieldRow icon={<BankOutlined />} label="Plant Name" value={data.plant_name} />
                    <FieldRow icon={<UserOutlined />} label="Plant User" value={data.plant_user} />
                    <FieldRow icon={<TeamOutlined />} label="Plant HOD" value={data.plant_hod} />
                    <FieldRow icon={<FileTextOutlined />} label="Cost Center" value={data.cost_center} />
                    <FieldRow icon={<MailOutlined />} label="Owner Email" value={data.owner_email} />
                    <FieldRow icon={<PhoneOutlined />} label="Driver Mobile No" value={data.driver_mobile_no} />
                    <FieldRow icon={<FileTextOutlined />} label="AMNS WO" value={data.amns_wo} />
                    <FieldRow icon={<FileTextOutlined />} label="Line Item No" value={data.line_item_no} />
                    <FieldRow icon={<FileTextOutlined />} label="Billing Period" value={data.billing_cycle} />
                    <FieldRow icon={<DashboardOutlined />} label="Unit of Measure" value={data.unit_of_measure} />
                    <FieldRow icon={<FileTextOutlined />} label="Contract Rate" value={data.contract_rate} />
                    <FieldRow icon={<CalendarOutlined />} label="Service Start Date" value={data.service_start_date} />
                    <FieldRow icon={<CalendarOutlined />} label="Service End Date" value={data.service_end_date} />
                    <FieldRow icon={<ClockCircleOutlined />} label="Service Start Time" value={data.service_start_time} />
                    <FieldRow icon={<ClockCircleOutlined />} label="Service End Time" value={data.service_end_time} />
                    <FieldRow icon={<ClockCircleOutlined />} label="Last Location Date" value={data.last_location_date} />
                    <FieldRow icon={<ClockCircleOutlined />} label="Last Location Time" value={data.last_location_time} />
                    <FieldRow icon={<ClockCircleOutlined />} label="Last Location Fetched At" value={data.last_location_fetched_at} />
                    <FieldRow icon={<UserOutlined />} label="Created By" value={data.created_by} />
                </div>
                {data.additional_remarks && (
                    <div className="mt-4 rounded-lg bg-gray-50 px-4 py-3">
                        <div className="flex items-start gap-3">
                            <div className="text-red-600 text-lg mt-0.5"><FileTextOutlined /></div>
                            <div className="min-w-0 w-full">
                                <div className="text-xs uppercase tracking-wider text-slate-500">Additional Remarks</div>
                                <div className="text-slate-900 font-medium break-words whitespace-pre-wrap">
                                    {data.additional_remarks}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default EquipmentDetailView;
